import { useEffect } from 'react';
import RoadmapHero from './components/RoadmapHero';
import IntegratedGantt from './components/IntegratedGantt';
import MilestoneOverview from './components/MilestoneOverview';
import PhaseTimeline from './components/PhaseTimeline';
import CashFlowChart from './components/CashFlowChart';
import OfficetelTypeTable from './components/OfficetelTypeTable';
import PodiumLeaseTable from './components/PodiumLeaseTable';
import RiskDashboard from './components/RiskDashboard';
import RoadmapFooter from './components/RoadmapFooter';

export default function RoadmapPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative">
      <RoadmapHero />
      <div id="integrated-gantt">
        <IntegratedGantt />
      </div>
      <div id="milestones">
        <MilestoneOverview />
      </div>
      <div id="phase-timeline">
        <PhaseTimeline />
      </div>
      <div id="cashflow">
        <CashFlowChart />
      </div>
      <div id="officetel-types">
        <OfficetelTypeTable />
      </div>
      <div id="podium-lease">
        <PodiumLeaseTable />
      </div>
      <div id="risk">
        <RiskDashboard />
      </div>
      <RoadmapFooter />
    </div>
  );
}